import { Injectable } from '@angular/core';
import {AdminSettings, DocumentsSettings} from '../model/adminSettings';

@Injectable({
  providedIn: 'root'
})
export class AdminStorageService {
  private readonly ADMIN_KEY = 'adminSettings';
  private readonly DOCUMENTS_KEY = 'documentsSettings';

  public setAdminSetting(settings: AdminSettings): void {
    localStorage.setItem(this.ADMIN_KEY, JSON.stringify(settings));
  }

  public getAdminSetting(): AdminSettings {
    const settings = localStorage.getItem(this.ADMIN_KEY);
    return settings ? new AdminSettings(JSON.parse(settings)) : new AdminSettings();
  }

  public setDocumentsSetting(settings: DocumentsSettings): void {
    localStorage.setItem(this.DOCUMENTS_KEY, JSON.stringify(settings));
  }

  public getDocumentsSetting(): DocumentsSettings {
    const settings = localStorage.getItem(this.DOCUMENTS_KEY);
    return settings ? new DocumentsSettings(JSON.parse(settings)) : new DocumentsSettings();
  }
}
